const reportWebVitals = () => {}; export default reportWebVitals;
